import { useEffect } from "react";
import { Button, Text } from "../../../elements";
import { useCookieConsent } from "../hooks";

import styles from "./cookie-notice.module.css";

export function CookieNotice() {
  const {
    cookieConfig,
    routes,
    fetchCookieConfig,
    handleSaveConsent,
    openModal,
  } = useCookieConsent();

  useEffect(() => {
    fetchCookieConfig();
  }, [fetchCookieConfig]);

  return cookieConfig?.showCookieNotice ? (
    <div className={styles.Container}>
      <div className={styles.Wrapper}>
        <div className={styles.TextWrapper}>
          <Text variant="body-semibold-xsmall">
            A Webmotors usa Cookies, pequenos arquivos para aprimorar e proteger
            a sua experiência :)
          </Text>
          <Text variant="body-semibold-xsmall">
            <Text
              onClick={openModal}
              className={styles.Link}
              variant="body-semibold-xsmall"
              as="span"
            >
              <span
                data-qa="cookie-notice-mobile-call-cookie_control"
                className="d-mobile-inline-block"
              >
                Toque aqui
              </span>
              <span
                data-qa="cookie-notice-desktop-call-cookie_control"
                className="d-desktop-inline-block"
              >
                Clique aqui
              </span>
            </Text>{" "}
            para mudar suas preferências ou saiba mais nos nossos{" "}
            <Text
              className={styles.ExternalLink}
              as="a"
              variant="body-bold-xsmall"
              href={routes.INSTITUTIONAL.PRIVACY}
              target="_blank"
              data-qa="cookie-notice-institutional_privacy"
            >
              Termos de Uso e Política de Privacidade
            </Text>{" "}
            e{" "}
            <Text
              className={styles.ExternalLink}
              as="a"
              variant="body-bold-xsmall"
              href={routes.INSTITUTIONAL.COOKIE_POLICY}
              target="_blank"
              data-qa="cookie-notice-cookie_privacy"
            >
              Política de Cookies
            </Text>
          </Text>
        </div>
        <Button
          className={styles.Button}
          onClick={handleSaveConsent}
          data-qa="cookie-notice-save_consent"
        >
          Entendi
        </Button>
      </div>
    </div>
  ) : null;
}
